// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Definición de la colección LoginColl baked at build time.
// NO EDITAR: se regenera en cada build.

export const COLL_DEF = {
  "name": "LoginColl",
  "tableName": "LoginColl",
  "tablePrefix": "gen",
  "idFieldName": "ROWID",
  "fields": [
    {
      "name": "IBD_LOGO",
      "type": "IMG"
    },
    {
      "name": "USER",
      "type": "T",
      "title": "Usuario"
    },
    {
      "name": "PWD",
      "type": "X",
      "title": "Contrase�a"
    },
    {
      "name": "BG_IMAGE",
      "type": "IMG"
    },
    {
      "name": "ROWID",
      "type": "T",
      "size": 32
    }
  ],
  "special": true
} as const;
